// @flow

import React from "react";
import { localize } from "redux-i18n";
import { ButtonGroup, Button, type StepProps } from "@components";
import type { AddNotificationData } from "@modules/shared/reducer/employee-notifications/types";
import type { EmployeeType } from "@modules/employee/types";
import StepDateFields from "./step-date-fields";

type OwnProps = $Exact<{
  data: $Exact<{
    notificationType: ?string,
  }>,
  notificationData: AddNotificationData | null,
  notificationTypes: Array<$Exact<{ title: string, const: string }>>,
  employeeToAdd: EmployeeType,
  recipient?: EmployeeType,
  isOpen: boolean,
}>;

type Props = $Exact<{
  ...StepProps,
  ...PropsFromLocalize,
  ...OwnProps,
}>;

export class Step2ConfigureNotification extends React.Component<Props> {
  componentDidMount() {
    if (this.props.notificationData && this.props.notificationData.notificationType) {
      this.props.onChange(
        {
          notificationType: this.props.notificationData.notificationType,
        },
        true,
      );
    }
  }

  componentDidUpdate(prevProps: Props) {
    if (this.props.editable && !prevProps.editable) {
      this.props.onChange(
        {
          notificationType: this.props.notificationTypes && this.props.notificationTypes[0].const,
        },
        true,
      );
    }
  }

  handleButtonClick = (type: string) => () => {
    this.props.onChange({
      notificationType: type,
    });
  };

  render() {
    if (!this.props.editable) {
      return null;
    }

    return (
      <div className="w-100 d-flex justify-content-center">
        <div className="col-sm-8">
          <span className="pb-1">{this.props.t("NOTIFICATION_TYPE")}</span>
          <ButtonGroup className="mt-1 mb-4" fillSpace>
            {this.props.notificationTypes.map(type => (
              <Button
                key={type.const}
                color={this.props.data.notificationType === type.const ? "selected" : null}
                onClick={this.handleButtonClick(type.const)}
              >
                {this.props.t(type.const)}
              </Button>
            ))}
          </ButtonGroup>
          {this.props.isOpen && <StepDateFields notificationData={this.props.notificationData} />}
        </div>
      </div>
    );
  }
}

export default localize()(Step2ConfigureNotification);
